<script>

    export default {
        name: 'Newsletter',
        data() {
            return {
                email: '',
                emailString: '',
                formSuccess: false,
                formMessage: '',
                loading: false,
                currentLang: window.lang || 'en',
            };
        },
        methods: {
            sendData() {
                this.loading = true
                if (!this.errors.has('email') && this.emailString.length) {
                    this.$jsonp('https://community.us10.list-manage.com/subscribe/post?u=c0a86d53bc94b0baeb367c299&amp;id=f86f789fe0', {
                        EMAIL: this.emailString,
                        callbackQuery: 'c',
                        callbackName: 'jsonpFunc',
                    }).then((json) => {
                        this.loading = false
                        if (json.result === 'success') {
                            this.formSuccess = true;
                            this.formMessage = json.msg;
                        } else {
                            this.formSuccess = false;
                            this.formMessage = json.msg;
                        }
                    });
                } else {
                    this.loading = false;
                }
            },
        },
    };
</script>
